
// Images config options
const imagesConfig = () => {
    return {
        class: ['splide-images'],
        type: 'loop',
        perPage: 1,
    };
}

// News config options
const newsConfig = () => {
    return {
        class: ['splide-news'],
        type: 'loop',
        perPage: 1,
        autoplay: 'play',
        interval: 5000,
        pauseOnHover: true,
    };
}

// Documents config options
const documentsConfig = () => {
    return {
        type: 'loop',
        class: ['splide-documents', 'splide-fadeaway'],
        autoWidth: true,
        padding: '3rem',
        focus : 'center',
        perPage: 1,
        slidesGap: '48', // 3rem = 48px (1rem = 16px)
    };
}

// Inernal content config options
const internalContentConfig = () => {
    return {
        type: 'loop',
        class: ['splide-internal-content', 'splide-fadeaway'],
        autoWidth: true,
        padding: '0',
        focus : 'center',
        perPage: 1,
        slidesMin: 2,
        slidesGap: '10',
    };
}

const allOptions = {
    images: imagesConfig(),
    documents: documentsConfig(),
    internal_content: internalContentConfig(),
    news: newsConfig(),
}

// Get config options for the carousel from the element
export const getConfigOptions = (element) => {
    const optionsKey = element.dataset?.optionsConfigKey;
    const options = allOptions?.[optionsKey] ? allOptions[optionsKey] : null;
    if(!options) {
        return;
    }

    options['dataAttributes'] = {};

    // Add to options array, data attributes from the element
    const dataAttributes = element.dataset;
    for (const key in dataAttributes) {
        options['dataAttributes'][key] = dataAttributes[key];
    }
    
    // Check for extra options
    const slidesSelector = options.dataAttributes?.slidesSelector;
    if (!slidesSelector) {
        console.error("No slides selector set for carousel component");
        return;
    }

    return options;
}

